<template>
  <v-menu
    offset-y
    left
    nudge-bottom="22"
    :elevation="$vuetify.theme.dark ? 9 : 8"
    content-class="list-style notification-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        class="app-bar-notification-activator"
        v-bind="attrs"
        v-on="on"
      >
        <v-badge
          :content="badgeCountLabel"
          :value="notificationCount > 0"
          color="error"
          overlap
        >
          <v-icon>
            {{ icons.mdiBellOutline }}
          </v-icon>
        </v-badge>
      </span>
    </template>
    <v-card class="app-bar-notification-content-container">
      <perfect-scrollbar
        class="ps-user-notifications"
        :options="perfectScrollbarOptions"
      >
        <v-list class="py-0">
          <!-- Header -->
          <v-list-item
            class="d-flex"
            link
          >
            <div class="d-flex align-center justify-space-between flex-grow-1">
              <span class="font-weight-semibold">Notificações</span>
              <v-chip
                class="v-chip-light-bg primary--text font-weight-semibold"
                small
              >
                {{ notificationCount }} Não Lidas
              </v-chip>
            </div>
          </v-list-item>
          <v-divider></v-divider>

          <!-- Notifications -->
          <template v-for="(notification, index) in getNotifications">
            <v-list-item
              :key="notification.title"
              link
              @click="showDrawerNotification(notification)"
            >
              <!-- Avatar -->
              <!-- <v-list-item-avatar
                :class="[
                  { 'v-avatar-light-bg primary--text justify-center': notification.user && !notification.user.avatar },
                ]"
                size="38"
              >
                <v-img
                  v-if="notification.user && notification.user.avatar"
                  :src="notification.user.avatar"
                ></v-img>
                <span
                  v-else-if="notification.user && !notification.user.avatar"
                  class="text-lg"
                  >{{ getInitialName(notification.user.name) }}</span
                >
                <v-img
                  v-else
                  :src="notification.service.icon"
                ></v-img>
              </v-list-item-avatar> -->
              <span
                style="font-size: 16px"
                class="tertiary--text"
              >
                <v-avatar
                  class="mt-2 mb-2 mr-3"
                  size="40"
                  outlined
                >
                  <v-img
                    v-if="notification.photo_base64"
                    :src="notification.photo_base64"
                  />
                  <v-icon
                    v-if="!notification.photo_base64"
                    color="secondary"
                    size="40"
                  >
                    {{ icons.mdiEmailNewsletter }}
                  </v-icon>
                </v-avatar>
              </span>
              <!-- Content -->
              <v-list-item-content class="d-block">
                <v-list-item-title class="text-sm font-weight-semibold">
                  {{ notification.title }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-sm">
                </v-list-item-subtitle>
              </v-list-item-content>

              <!-- Item Action/Time -->
              <v-list-item-action>
                <span class="text--secondary text-xs">{{ formatDateString(notification.created_at) }}</span>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="index"></v-divider>
          </template>
          <v-list-item
            key="read-all-btn"
            class="read-all-btn-list-item"
          >
            <v-btn
              block
              color="primary"
              @click="showNotification"
            >
              Ler todas as notificações
            </v-btn>
          </v-list-item>
        </v-list>
      </perfect-scrollbar>
    </v-card>
  </v-menu>
</template>

<script>
import { mdiBellOutline } from '@mdi/js'
import { getInitialName } from '@core/utils'
import DrawerNotification from '@/views/Messages/components/DrawerNotification.vue'

// 3rd Party
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { icons, format } from '@/plugins/helper'

export default {
  components: {
    // 3rd Party
    PerfectScrollbar,
    DrawerNotification,
  },
  mixins: [icons, format],
  data() {
    return {
      dialogDrawerNotification: false,
      notifications: [],
      notification: null,
      perfectScrollbarOptions: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
      icons: {
        mdiBellOutline,
      },
    }
  },
  created() {
    this.loadNotifications()
  },
  computed: {
    ...mapGetters('Notification', ['getNotifications']),
    notificationCount() {
      return this.getNotifications.length
    },
    badgeCountLabel() {
      return this.notificationCount > 99 ? '99+' : this.notificationCount
    },
  },
  methods: {
    ...mapActions('Notification', ['getAllUnread']),
    ...mapMutations('Notification', ['setNotifications']),
    getInitialName,
    loadNotifications() {
      this.getAllUnread()
        .then(response => {
          this.setNotifications(response.data)
        })
        .catch(error => {
          console.error('Error fetching notifications:', error)
        })
    },
    showNotification() {
      this.$router.push('/message')
    },
    showDrawerNotification(notification) {
      this.$router.push({ name: 'message', params: { notificationId: notification.id } })

      // this.notification = notification
      // this.dialogDrawerNotification = true
      // this.$router.replace({ name: 'message', params: { notificationId: notification.id } })

      // Marcar como lida
      // if (notification.status === 'unread') {
      //   this.markAsRead(notification.id)
      //     .then(() => {
      //       notification.status = 'read'
      //     })
      //     .catch(() => {
      //       console.error('Erro ao marcar notificação como lida')
      //     })
      //     .finally(() => {})
      // }
    },
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.app-bar-notification-content-container {
  .read-all-btn-list-item {
    padding-top: 14px;
    padding-bottom: 14px;
    min-height: unset;
  }
}

.ps-user-notifications {
  max-height: calc(var(--vh, 1vh) * 80);
}

.notification-menu-content {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    min-width: calc(100vw - (1.5rem * 2)) !important;
    left: 50% !important;
    transform: translateX(-50%);
  }
}

.app-bar-notification-activator {
  display: inline-flex;
  cursor: pointer;
}
</style>
